import React, { Component } from 'react';
import Constants from '../../../../definitions/constants';
import JavascriptUtilsTooling from '../../../../tooling/javascriptUtilsTooling';
import toastr from 'toastr';

import TextBox from './textBox';
import FetchAutocompleteTextBox from './fetchAutocompleteTextBox';

class FetchAutocompleteSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleOnClear = (event) => {
    if(this.props.onChange) {
      this.props.onChange({
        currentTarget: {
          dataset: {
            path: this.props["data-path"],
            selectlist: this.props["data-selectlist"],
          },
          value: ""
        }
      });
    }
  };
  
  render() {
    const {
      className,
      value,
      options,
      onChange,
      labelLocale,
      valueAccesor,
      labelAccesor,
      disabled,
      fetchListAction,
      loadingFetch,
      minSearchLength,
      nonObjectValue
    } = this.props;
    const dataPath = this.props["data-path"];    
    const searchData = this.props["data-searchdata"];
    let finalValue = "";
    if(!nonObjectValue) {
      let forceValueObject = (value && options) ? options.find(item => item.value == value) : null;
      finalValue = value && forceValueObject ?  forceValueObject.label : "";     
    }
    else {
      finalValue = value;
    }
    
    return (
      <div className={"custom-input fetch-autocomplete-select" + (className ? " " + className : "")}>
        <FetchAutocompleteTextBox
          className={(value && !disabled) ? "light-disabled" : ""}
          forcedValue={finalValue}
          labelLocale={labelLocale}
          disabled={value ? true : disabled}
          fetchAction={fetchListAction}
          loadingFetch={loadingFetch}
          fetchedData={options ? options : []}
          onClickOption={onChange}
          minSearchLength={minSearchLength}
          data-selectlist={"true"}
          data-path={dataPath}
          data-searchdata={searchData}
        />
        {value ? (
          <i 
            className="fas fa-times-circle"
            onClick={this.handleOnClear}
          />
        ) : null }
      </div>
    );
  }
}

export default FetchAutocompleteSelect;



// WEBPACK FOOTER //
// ./source/client/components/common/inputs/fetchAutocompleteSelect.jsx